module.exports = __webpack_public_path__ + "img/caminhao-de-entrega.29b58499.png";